const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

const getAuthHeaders = () => {
    const token = localStorage.getItem('authToken');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export async function getAcademias(searchTerm = '') {
    try {
        let url = `${API_BASE}/catalogos/academias/`;
        if (searchTerm) {
            url += `?search=${encodeURIComponent(searchTerm)}`;
        }
        console.log('[academias.js] Llamando a:', url);
        const res = await fetch(url, {
            headers: getAuthHeaders()
        });
        console.log('[academias.js] Status:', res.status);
        if (!res.ok) {
            console.error('[academias.js] Error en respuesta:', res.status, res.statusText);
            return [];
        }
        const data = await res.json();
        console.log('[academias.js] Datos recibidos:', data);
        
        // Manejar respuesta paginada o array directo
        const academias = Array.isArray(data) ? data : (data.results || []);
        
        if (academias.length > 0) {
            const mapped = academias.map(a => ({
                id: a.id_academia,
                nombre: a.nombre_academia,
                codigo: a.codigo_academia || '',
                descripcion: a.descripcion || '',
                estado: a.activo ? 'ACTIVO' : 'INACTIVO',
                institucion: a.id_institucion || '',
                institucion_nombre: a.institucion_nombre || ''
            }));
            console.log('[academias.js] Academias mapeadas:', mapped);
            return mapped;
        }
        console.warn('[academias.js] No hay academias en la respuesta');
        return [];
    } catch (err) {
        console.error('[academias.js] Error al cargar academias:', err);
        return [];
    }
}

export async function createAcademia(data) {
    try {
        console.log('[academias.js] Creando academia:', data);
        const res = await fetch(`${API_BASE}/catalogos/academias/`, {
            method: 'POST',
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                nombre_academia: data.nombre,
                codigo_academia: data.codigo,
                descripcion: data.descripcion,
                activo: data.estado === 'ACTIVO',
                id_institucion: data.institucion || 1
            })
        });
        
        if (!res.ok) {
            const errorData = await res.json();
            console.error('[academias.js] Error al crear academia:', errorData);
            throw new Error(errorData.message || 'Error al crear academia');
        }
        
        const result = await res.json();
        console.log('[academias.js] Academia creada:', result);
        return result;
    } catch (err) {
        console.error('[academias.js] Error en createAcademia:', err);
        throw err;
    }
}

export async function updateAcademia(id, data) {
    try {
        console.log('[academias.js] Actualizando academia:', id, data);
        const res = await fetch(`${API_BASE}/catalogos/academias/${id}/`, {
            method: 'PUT',
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                nombre_academia: data.nombre,
                codigo_academia: data.codigo,
                descripcion: data.descripcion,
                activo: data.estado === 'ACTIVO',
                id_institucion: data.institucion || 1
            })
        });
        
        if (!res.ok) {
            const errorData = await res.json();
            console.error('[academias.js] Error al actualizar academia:', errorData);
            throw new Error(errorData.message || 'Error al actualizar academia');
        }
        
        const result = await res.json();
        console.log('[academias.js] Academia actualizada:', result);
        return result;
    } catch (err) {
        console.error('[academias.js] Error en updateAcademia:', err);
        throw err;
    }
}

export async function deleteAcademia(id) {
    try {
        console.log('[academias.js] Eliminando academia:', id);
        const res = await fetch(`${API_BASE}/catalogos/academias/${id}/`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });
        
        if (!res.ok) {
            const errorData = await res.json().catch(() => ({}));
            console.error('[academias.js] Error al eliminar academia:', errorData);

            // Mensaje amigable cuando la academia tiene registros relacionados
            let message = 'No se puede eliminar la academia porque tiene información relacionada (por ejemplo, materias o estudiantes).';

            // Si el backend envía un detalle más específico, úsalo
            if (errorData && (errorData.detail || errorData.message)) {
                message = errorData.detail || errorData.message;
            }

            throw new Error(message);
        }
        
        console.log('[academias.js] Academia eliminada exitosamente');
        return true;
    } catch (err) {
        console.error('[academias.js] Error en deleteAcademia:', err);
        throw err;
    }
}
